import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { BodyText, HeroCurrency } from '@paypalcorp/pp-react';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_rtlCode__BNDgO {\n  order: 1;\n}\n\n.styles-module_readOnly__mJHbD {\n  pointer-events: none;\n}\n\n.styles-module_currencyAlign__4IMaI {\n  text-align: center;\n  margin-bottom: 0.675rem;\n}\n\n.styles-module_caamlError__7GHJi {\n  margin-top: 2.5rem;\n}\n";
var styles = {"rtlCode":"styles-module_rtlCode__BNDgO","readOnly":"styles-module_readOnly__mJHbD","currencyAlign":"styles-module_currencyAlign__4IMaI","caamlError":"styles-module_caamlError__7GHJi"};
styleInject(css_248z);

// This is a function added as an workaround for
// the issue that, for currencies with 0 decimal points
// if we pass amount as 100.00, it will be formatted to
// 10000, which is wrong
// TODO: remove this once pp-react makes the fix
function parseAmount(amount) {
  // If the normalized amount received is having decimal points
  // as zero, we truncated the part after decimal point from the
  // amount string
  if (Number(amount) % 1 === 0 && amount.indexOf('.') >= 0) {
    return amount.slice(0, amount.indexOf('.'));
  }
  return amount;
}

function SingleAmount(_ref) {
  var amount = _ref.amount,
    currencyCode = _ref.currencyCode,
    currencySymbol = _ref.currencySymbol,
    _ref$directionality = _ref.directionality,
    directionality = _ref$directionality === void 0 ? 'ltr' : _ref$directionality,
    handleAmount = _ref.handleAmount,
    showValidationError = _ref.showValidationError,
    validationErrorMessage = _ref.validationErrorMessage,
    isEditable = _ref.isEditable,
    _ref$isPreview = _ref.isPreview,
    isPreview = _ref$isPreview === void 0 ? false : _ref$isPreview,
    handleAmountFocus = _ref.handleAmountFocus,
    getAmountBeforeFee = _ref.getAmountBeforeFee,
    isOptInCoverFee = _ref.isOptInCoverFee,
    isAtLandingPage = _ref.isAtLandingPage,
    handleTrackError = _ref.handleTrackError,
    validationErrorCode = _ref.validationErrorCode,
    maskOptions = _ref.maskOptions,
    caamlErrorStyle = _ref.caamlErrorStyle;
  var handleAccept = function handleAccept(value, unmaskedValue) {
    if (!isPreview || isEditable) {
      handleAmount === null || handleAmount === void 0 || handleAmount(unmaskedValue);
    }
  };
  function getErrorText() {
    if (showValidationError) {
      handleTrackError === null || handleTrackError === void 0 || handleTrackError(validationErrorCode, validationErrorMessage, 'currencyAmount');
      return validationErrorMessage;
    }
    return '';
  }
  useEffect(function () {
    // In case user opts in for cover fee and goes back to
    // landing page from guest page, we need to restore back
    // user's original entered amount
    if (isOptInCoverFee !== null && isOptInCoverFee !== void 0 && isOptInCoverFee() && isAtLandingPage !== null && isAtLandingPage !== void 0 && isAtLandingPage()) {
      var amountBeforeFee = getAmountBeforeFee === null || getAmountBeforeFee === void 0 ? void 0 : getAmountBeforeFee();
      amountBeforeFee && handleAccept(amountBeforeFee, amountBeforeFee);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    dir: directionality,
    tabIndex: isEditable ? '0' : '-1'
  }, directionality === 'rtl' ? /*#__PURE__*/React.createElement(BodyText, {
    strong: true,
    className: "".concat(styles.rtlCode, " ").concat(styles.currencyAlign),
    tabIndex: isEditable ? '0' : '-1'
  }, currencyCode) : null, currencySymbol ? /*#__PURE__*/React.createElement(HeroCurrency, {
    name: "myHeroCurrency",
    className: !isEditable ? styles.readOnly : '',
    onAccept: handleAccept,
    value: parseAmount(amount),
    prefix: currencySymbol,
    maskOptions: maskOptions || {
      mask: Number
    },
    align: "center",
    currencyType: currencyCode,
    errorText: getErrorText(),
    onFocus: handleAmountFocus,
    tabIndex: isEditable ? '0' : '-1'
  }) : /*#__PURE__*/React.createElement(HeroCurrency, {
    name: "myHeroCurrency",
    className: !isEditable ? styles.readOnly : '',
    onAccept: handleAccept,
    value: parseAmount(amount),
    prefix: " ",
    align: "center",
    maskOptions: maskOptions || {
      mask: Number
    },
    currencyType: currencyCode,
    errorText: getErrorText(),
    onFocus: handleAmountFocus,
    tabIndex: isEditable ? '0' : '-1'
  }), directionality === 'ltr' ? /*#__PURE__*/React.createElement(BodyText, {
    strong: true,
    className: "".concat(styles.currencyAlign, " ").concat(caamlErrorStyle && styles.caamlError),
    tabIndex: isEditable ? '0' : '-1'
  }, currencyCode) : null);
}
SingleAmount.propTypes = {
  amount: PropTypes.string,
  currencyCode: PropTypes.string,
  directionality: PropTypes.string,
  isEditable: PropTypes.bool,
  isPreview: PropTypes.bool,
  handleAmount: PropTypes.func,
  getAmountBeforeFee: PropTypes.func,
  isOptInCoverFee: PropTypes.func,
  isAtLandingPage: PropTypes.func,
  handleAmountFocus: PropTypes.func,
  showValidationError: PropTypes.bool,
  validationErrorMessage: PropTypes.string,
  handleTrackError: PropTypes.func,
  validationErrorCode: PropTypes.string,
  currencySymbol: PropTypes.string,
  maskOptions: PropTypes.object,
  caamlErrorStyle: PropTypes.bool
};

export { SingleAmount };
